import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param serviceAssetSchemaModel ServiceAssetSchemaModel
 * @param organisation OrganisationModel
 * @return {Promise<any>|Promise}
 */
export default (function (serviceAssetSchemaModel, organisation) {
    var url = applyPathVariables(EndPoints.SERVICE_ASSET_SCHEMA_REMOVE, {
        organisationId: organisation.id,
        assetId: serviceAssetSchemaModel.assetId,
        schemaId: serviceAssetSchemaModel.schemaId
    });
    var request = new Request({ method: Methods.DELETE, url: url, withCredentials: true });
    return request.execute();
});
